import { TDailyrent } from './dailyrent';

/* eslint-disable max-lines */
export type TRecommendation = {
  /** Данные об авторе **/
  author?: IAuthorMobileSiteSchema;
  /** Данные для calltracking **/
  calltracking?: ICallTrackingInfoSchema;
  /** Признак возможности забронировать объект онлайн (для Посуточной аренды) (?) **/
  canBeBooked?: boolean;
  /** Категория **/
  category: ECategory;
  /** Значение поля непонятно **/
  dealRentEnabled?: boolean;
  /** Тип сделки **/
  dealType: EDealType;
  /** Лейбл для аналитики **/
  gaLabel: string;
  /** Гео **/
  geo: IGeoMobSiteSchema;
  /** Дополнительная информация **/
  info?: string;
  /** Подключен ли колтрекинг **/
  isCalltrackingEnabled?: boolean;
  /** Партнёр ЦИАН **/
  isCianPartner: boolean;
  /** Является застройщиком **/
  isDeveloper?: boolean;
  /** Id объявления **/
  offerId: number;
  /** Тип объявления **/
  offerType: EOfferType;
  /** Доступные для звонка номера (?) **/
  phoneNumbers?: IPhoneSchema[];
  /** Фото объявления **/
  photos: IPhotoMobSiteSchema[];
  /** Цена объявления **/
  price: IPriceMobSiteSchema;
  /** Ссылка на объявление **/
  url: string;
  /** Агент, нужно для проверки доступности звонка по рабочим часам **/
  agentAvailability?: IAgentAvailabilityInfoMobSiteSchema;
  /** Поля, относящиеся к посуточной */
  dailyrent: TDailyrent;
};

export interface IAuthorMobileSiteSchema {
  /** Ссылка на аватар **/
  avatar?: string;
  /** Отображаемое имя **/
  displayName?: string;
  /** Застройщик, Представитель застройщика **/
  fromDeveloper?: string;
  /** ID агента строкой **/
  id: string;
  /** Доступность чатов у автора **/
  isChatsEnabled: boolean;
  /** Представитель застройщика из фабрики лидов **/
  isFromLeadFactory?: boolean;
  /** Профессионал **/
  isPro: boolean;
}

export interface ICallTrackingInfoSchema {
  /** ID для подмены номера с comagic **/
  comagicId?: number;
  /** Телефон подменен на номер консультанта **/
  isConsultantPhone?: boolean;
  /** ID ЖК для comagic **/
  newbuildingId?: number;
}

export interface IPhoneSchema {
  /** Код страны **/
  countryCode?: string;
  /** Номер **/
  number?: string;
}

export interface IPhotoMobSiteSchema {
  /** ID фото **/
  id: number;
  /** Ссылка на исходное изображение **/
  url: string;
}

export interface IPriceMobSiteSchema {
  /** Валюта **/
  currency: ECurrency;
  /** Сутки, месяц **/
  period?: EPeriod;
  /** Цена, число **/
  value: number;
}

export interface IAgentAvailabilityInfoMobSiteSchema {
  /** Специалист доступен по телефону **/
  available?: boolean;
  /** Агент доступен с (в таймзоне агента) **/
  availableFrom?: string;
  /** Агент доступен по (в таймзоне агента) **/
  availableTo?: string;
  /** Сообщение **/
  message?: string;
  /** Заголовок **/
  title?: string;
  /** Идентификатор пользователя **/
  userId?: number;
  /** Дата последнего дня отпуска **/
  vacationTo?: string;
}

export enum ECurrency {
  /** € **/
  'Eur' = 'eur',
  /** руб. **/
  'Rur' = 'rur',
  /** $ **/
  'Usd' = 'usd',
}

export enum EPeriod {
  /** В сутки **/
  'Day' = 'day',
  /** В месяц **/
  'Month' = 'month',
}

export enum ECategory {
  /** Аренда койко-места **/
  'BedRent' = 'bedRent',
  /** Аренда здания **/
  'BuildingRent' = 'buildingRent',
  /** Продажа здания **/
  'BuildingSale' = 'buildingSale',
  /** Аренда готового бизнеса **/
  'BusinessRent' = 'businessRent',
  /** Продажа готового бизнеса **/
  'BusinessSale' = 'businessSale',
  /** Аренда автосервис **/
  'CarServiceRent' = 'carServiceRent',
  /** Продажа автосервиса **/
  'CarServiceSale' = 'carServiceSale',
  /** Аренда коммерческой земли **/
  'CommercialLandRent' = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  'CommercialLandSale' = 'commercialLandSale',
  /** Аренда коттеджа **/
  'CottageRent' = 'cottageRent',
  /** Продажа коттеджа **/
  'CottageSale' = 'cottageSale',
  /** Посуточная аренда койко-места **/
  'DailyBedRent' = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  'DailyFlatRent' = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  'DailyHouseRent' = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  'DailyRoomRent' = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  'DomesticServicesRent' = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  'DomesticServicesSale' = 'domesticServicesSale',
  /** Аренда квартиры **/
  'FlatRent' = 'flatRent',
  /** Продажа квартиры **/
  'FlatSale' = 'flatSale',
  /** Продажа доли в квартире **/
  'FlatShareSale' = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  'GarageRent' = 'garageRent',
  /** Продажа гаража **/
  'GarageSale' = 'garageSale',
  /** Аренда дома/дачи **/
  'HouseRent' = 'houseRent',
  /** Продажа дома/дачи **/
  'HouseSale' = 'houseSale',
  /** Аренда части дома **/
  'HouseShareRent' = 'houseShareRent',
  /** Продажа части дома **/
  'HouseShareSale' = 'houseShareSale',
  /** Аренда производства **/
  'IndustryRent' = 'industryRent',
  /** Продажа производство **/
  'IndustrySale' = 'industrySale',
  /** Продажа участка **/
  'LandSale' = 'landSale',
  /** Продажа квартиры в новостройке **/
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  /** Аренда офиса **/
  'OfficeRent' = 'officeRent',
  /** Продажа офиса **/
  'OfficeSale' = 'officeSale',
  /** Аренда общепита **/
  'PublicCateringRent' = 'publicCateringRent',
  /** Продажа общепита **/
  'PublicCateringSale' = 'publicCateringSale',
  /** Аренда комнаты **/
  'RoomRent' = 'roomRent',
  /** Продажа комнаты **/
  'RoomSale' = 'roomSale',
  /** Аренда торговой площади **/
  'ShoppingAreaRent' = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  'ShoppingAreaSale' = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  'TownhouseRent' = 'townhouseRent',
  /** Продажа таунхауса **/
  'TownhouseSale' = 'townhouseSale',
  /** Аренда склада **/
  'WarehouseRent' = 'warehouseRent',
  /** Продажа склада **/
  'WarehouseSale' = 'warehouseSale',
}

export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}

export enum EOfferType {
  /** коммерческая **/
  'Commercial' = 'commercial',
  /** квартиры **/
  'Flat' = 'flat',
  /** новостройки **/
  'Newobject' = 'newobject',
  /** загородка **/
  'Suburban' = 'suburban',
}

export interface IGeoMobSiteSchema {
  /** Список адресных элементов **/
  address: IAddressDetailMobSiteSchema[];
  /** Список шоссе **/
  highways: IHighwayMobSiteSchema[];
  /** Список ЖД станций **/
  railways?: IRailwayMobSiteSchema[];
  /** ID региона **/
  regionId: number;
  /** Список метро **/
  undergrounds: IUndergroundMobSiteSchema[];
}

export interface IAddressDetailMobSiteSchema {
  /** Название **/
  key: string;
  /** Значение параметра **/
  value: string;
}

export interface IHighwayMobSiteSchema {
  /** Расстояние от МКАД **/
  distance?: string;
  /** ID шоссе **/
  id: number;
  /** Название станции **/
  name: string;
}

export interface IRailwayMobSiteSchema {
  /** Список ID направлений **/
  directionIds?: number[];
  /** Расстояние до станции **/
  distance?: number;
  /** ID ЖД-станции **/
  id?: number;
  /** Название станции **/
  name?: string;
  /** Время до станции **/
  time?: number;
  /** Способ передвижения до ЖД **/
  travelType?: ETravelType;
}

export enum ETravelType {
  /** На транспорте **/
  'ByCar' = 'byCar',
  /** Пешком **/
  'ByFoot' = 'byFoot',
}

export interface IUndergroundMobSiteSchema {
  /** ID метро **/
  id: number;
  /** HEX код цвета станции метро **/
  lineColor?: string;
  /** Название станции **/
  name: string;
  /** Время до метро **/
  time?: string;
  /** Способ передвижения до станции **/
  transportType?: ETransportType;
  /** Строящаяся станция **/
  underConstruction: boolean;
}

export enum ETransportType {
  /** Транспортом **/
  'Transport' = 'transport',
  /** Пешком **/
  'Walk' = 'walk',
}
